import { getTermSetsByLabel } from "../../sharePoint/sharePointHelper";
import { paramDsNameDest, paramDsNameSrc } from "../constants/parameterNames";
import { typeDataSource } from "../constants/parameterTypes";
import makeTaxonomyNamespaces from "../helpers/taxonomyNamespaces";

const requiredParameters = [];
const optionalParameters = [
    {
        name: paramDsNameSrc,
        description: "GetTermsByLabel data connection",
        type: typeDataSource
    },
    {
        name: paramDsNameDest,
        description: "Destination source",
        type: typeDataSource
    },
];
const description = "Queries SharePoint’s TaxonomyClientService to obtain a list of TermSets that match the label (search term) provided by the user. Additional information on the metadata commands can be found http://www.infopathdev.com/files/folders/qrules/entry76371.aspx. This command takes no parameters.";

function GetTermsByLabel(params) {
    const cf = params.commonFunction;
    const taxonomyNamespaces = makeTaxonomyNamespaces();

    const basePathTermsByLabel = "/dfs:myFields/dfs:queryFields/tns:GetTermsByLabel/";

    function getNode(dataSource, xPath) {
        return dataSource.selectSingle(xPath, { namespaces: taxonomyNamespaces });
    }

    function getNodeValue(dataSource, xPath) {
        var node = getNode(dataSource, xPath);

        if (!node) {
            return null;
        }

        return node.value();
    }

    function setResultAsync(termStoreDoc, dsNameDest) {
        const dsDest = cf.getDataSource(dsNameDest);
        const xpathResult = "/ns1:QdabraRulesTermSets/ns1:GetTermsByLabel";
        const rootDest = getNode(dsDest, xpathResult);

        return rootDest.setContentAsync(termStoreDoc.documentElement);
    }

    const determineSiteUrl = (dcTermSetLabel) => {
        const dcUrl = dcTermSetLabel.getUrl();
        const matchIndex = dcUrl.search(new RegExp("/_vti_bin/taxonomyclientservice.asmx", "i"));

        if (matchIndex) {
            return dcUrl.substr(0, matchIndex);
        }

        return dcUrl;
    };

    async function executeAsync() {
        const dsNameSrc = cf.getParamValue(paramDsNameSrc, "GetTermsByLabel");
        const dsNameDest = cf.getParamValue(paramDsNameDest, "QdabraRules_TermSets");
        const shp = params.shpAccess;
        const dcTermSetLabel = cf.getDataConnection(dsNameSrc);
        const dsSource = cf.getDataSource(dsNameSrc);

        const searchText = getNodeValue(dsSource, basePathTermsByLabel + "tns:label");
        const lcid = getNodeValue(dsSource, basePathTermsByLabel + "tns:lcid");
        const matchOption = getNodeValue(dsSource, basePathTermsByLabel + "tns:matchOption");

        if (!searchText) {
            return {
                error: "Cannot execute query search text is required."
            };
        }

        const siteUrl = determineSiteUrl(dcTermSetLabel);

        const termSetXml = await getTermSetsByLabel(shp, siteUrl, lcid, searchText, matchOption);

        await setResultAsync(termSetXml, dsNameDest);

        return {
            success: true
        };
    }

    return {
        description,
        executeAsync,
        optionalParameters,
        requiredParameters
    };
}

export default GetTermsByLabel;